// extracted by mini-css-extract-plugin
export var alternate = "_7-j";
export var black = "_7-6";
export var blue = "_7-f";
export var blueLight = "_7-e";
export var brand = "_7-8";
export var darkMode = "_7-b";
export var error = "_7-a";
export var gray = "_7-5";
export var grayBlue = "_7-d";
export var iconWrapper = "_7-3";
export var inactive = "_7-7";
export var indigo = "_7-g";
export var orange = "_7-i";
export var pink = "_7-h";
export var primary = "_7-0";
export var purple = "_7-9";
export var success = "_7-4";
export var warning = "_7-c";
export var white = "_7-1";
export var whiteSuccess = "_7-2";